module.exports = __webpack_public_path__ + "assets/f60273e5f6aa4bffa5067e801bf25710.png";